'use client';


export default function LicenseSection() {
  return (
    <section className="py-12 bg-section-dark" aria-labelledby="license-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="glass rounded-2xl p-6" style={{ border: '1px solid rgba(245,158,11,0.2)' }}>
          <div className="flex items-start gap-3">
            <span className="text-2xl flex-shrink-0" aria-hidden="true">⚖️</span>
            <div>
              <h2 id="license-heading" className="font-bold text-base mb-2" style={{ color: 'var(--foreground)' }}>
                Usage &amp; License
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Individual collections may contain specific licensing terms. Buyers should review the license information included with the product and/or on the selected marketplace before commercial use, resale, redistribution or client usage. License terms vary by collection.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
